<template>
  <div>
    <div class="mt-6">
      <a
        :href="loginUrl"
        class="flex w-full items-center justify-center gap-3 rounded-lg border border-gray-300 bg-white px-4 py-2 text-gray-700 shadow-sm transition hover:bg-gray-100"
      >
        <img src="/images/front/google-icon.svg" alt="Google Logo" class="h-5 w-5" />
        <span class="text-md font-medium">{{ __('Sign in with Google')}}</span>
      </a>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue';

  const loginUrl = computed(() => `/login/google`);
</script>

